<template>
  <div class="rhlistDrawer">
    <Modal
      class="common-drawer newModal"
      v-model="showInDrawer"
      title="激活网关"
      width="480px"
      :mask-closable="false"
      @on-cancel="drwcloseDrawer"
      class-name="vertical-center-modal"
    >
      <Form
  
        @keydown.native.enter.prevent="hadner"
        ref="formValidate"
        :model="formData"
        :rules="ruleValidate"
        label-position="top"
      >
        <!-- <FormItem label="网关型号" prop="model">
         
          <Select ref="modelSelect"   :clearable="modelSelectSble" id="modelSelect" v-model="formData.model" placeholder="请选择">
            <Option :key="key" :value="type" v-for="(type, key) in models"
              >{{ type }}
            </Option>
          </Select>
        </FormItem> -->
        <FormItem label="网关名称" prop="nickName">
          <Input  name="mo-nickname" v-model="formData.nickName" placeholder="请输入" />
        </FormItem>
        <FormItem label="网关序列号（英文字母大写）" prop="sn">
          <Input v-model="formData.sn"  name="mo-sn" placeholder="请输入" />
        </FormItem>
        <FormItem label="驱动协议" prop="driverType">
          <Select ref="driverTypeSelect" :clearable="driverTypeSelectSble" id="driverTypeSelect" v-model="formData.driverType" placeholder="请选择">
            <Option :key="key" :value="type.name" v-for="(type, key) in driverTypeList">
              {{ type.name }}
            </Option>
          </Select>
        </FormItem>
        <Col span="24" >
          <FormItem label="所属客户" v-if="!userRole.includes('c')" prop="tenantId">
            <Select
              @on-change="slectmethods"
              v-model="formData.tenantId"
              placeholder="请选择"
              filterable
              id="mo-tenantId"
            >
              <Option
                :key="type.id"
                :value="type.id"
                v-for="type in list"
                >{{ type.value }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <!-- <Col span="24" v-if="userRole=='m1'">
          <FormItem label="所属客户"  prop="tenantId">
            <Select
            
              v-model="formData.tenantId"
              placeholder="请选择"
              filterable
            >
              <Option :key="type.id" :value="type.id"  v-for="type in dataCenter.consumer"   >{{ type.value }}</Option>
            </Select>
          </FormItem>
        </Col> -->
      </Form>
      <div class="drawer-footer" slot="footer">
        <Button
          type="primary"
          @click="submitForm('formValidate')"
          :loading="btnLoading"
          id="gat-sucess"
          >提交</Button
        >
        <Button style="margin-left: 8px" @click="drwcloseDrawer">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import { gatewayInsert, allDriver } from "@/api/knowledge/gateway";
import { mapState } from "vuex";
export default {
  props: {
    showDrawer: Boolean,
    closeDrawer: Function,

    getLists: Function,
    curItemDetail: Object,
    models: {},
    driverTypeList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState({
      dataCenter: (state) => state.dataCenter,
    }),
  },
  data() {
    return {
      modelSelectSble:false,
      driverTypeSelectSble: false,
      driverTypeSelect: null,
      list: [],
      userRole: ls.get("userRole"),
      showInDrawer: false,
      formData: {},
      btnLoading: false,
      formValidate: {},
      ruleValidate: {
        // model: [
        //   {
        //     required: true,
        //     message: "请选择网关类型",
        //     trigger: "blur,change",
        //   },
        // ],
        nickName: [
          {
            required: true,
            message: "请填写网关名称",
            trigger: "blur,change",
          },
        ],
        sn: [
          {
            required: true,
            message: "请填写序列号",
            trigger: "blur,change",
          },
        ],
        tenantId: [
          //  {
          //   required: true,
          //   message: "请填写Sn",
          //   trigger: "blur",
          // },
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.tenantId;
            
              if (value1) {
                callback();
              } else {
                callback(new Error("请选择客户"));
              }
            },
          },
        ],
      },
      userRole: ls.get("userRole"),
    };
  },
  mounted() {
    if (!['c0', 'c1'].includes(this.userRole)) {
      this.$store.dispatch("listCollection", "consumer"); // 客户
    }
  },
  methods: {
    drwcloseDrawer() {

 
      this.closeDrawer();
      this.$nextTick(async () => {
        await this.$c.sleep(300);
        this.$refs.formValidate.resetFields();
        this.cleartRest();
      });
    },
     cleartRest() {
      let t = setTimeout(() => {
        console.log("我清空了");
        this.modelSelectSble = true;
   
        this.$nextTick(async () => {
          this.$refs["modelSelect"].clearSingleSelect();
        
          let t1 = setTimeout(() => {
            this.modelSelectSble = false;
       
            clearTimeout(t1);
          }, 100);
          clearTimeout(t);
        });
      }, 300);
    },
    slectmethods(row) {
    },
    hadner() {
      return false;
    },
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.btnLoading = true;

        
          // 编辑
          let formDataCopy = {};
          formDataCopy = { ...this.formData };
           if(this.userRole.includes("c")){
            formDataCopy.tenantId=this.list[0].id
          }
          gatewayInsert(formDataCopy)
            .then((res) => {
        
              if (res.code === "00000") {
                this.$Message.success("提交网关激活");
                this.btnLoading = false;
                this.closeDrawer(); // 关闭弹窗
                this.getLists(); // 刷新列表
              } else {
                this.$Message.info(res.msg);
              }
            })
            .catch((error) => {
              this.btnLoading = false;
            });
          this.btnLoading = false;
        }
      });
    },
    reset(key) {
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
  },
  watch: {
    curItemDetail: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) this.$refs.formValidate.resetFields();
        if (newValue.id) this.formData = newValue;
        else this.formData = {};
      },
      deep: true,
    },
    showDrawer: {
      handler: function (newValue, oldValue) {
        if (this.userRole == "m0") {
          this.list = this.dataCenter.consumer.filter((e) => {
            if (e.groupAuthorityString == "rw") {
              return true;
            }
          });
        } else {
          this.list = this.dataCenter.consumer;
        }

        this.showInDrawer = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style lang='less' scoped>
.rhlistDrawer {
}
</style>